import React from 'react'
import './Contact.css';

const Contact = () => {
  return (
    <div>
        <section className='contact' id='contact'>
            <h2 className='heading'>Contact <span>Me</span></h2>

            <form action="#link" >
                <div className='input-box' >
                    <input type='text' placeholder='Full Name'></input>
                    <input type='email' placeholder='Email Address'></input>
                </div>          

                
                <textarea name='' id='' cols='30' rows='8' placeholder='Your Message'></textarea>
                <input type='submit' value="Send Message" className='btn'></input>
            </form>
        </section>
    </div>
  )
}

export default Contact